import keyMappings from './keyMappings';
export default function getKeys(key) {
  // check if any set of mappings has the key and return if so
  return keyMappings.find(mapping => Object.values(mapping).includes(key));
}